<template>
  <div class="customer">
     <div class="wrap">
       <div class="title">
        <h1>客户第一   真诚   激情   创新   执行</h1>
        <p>Customer first sincere passion innovation implementation</p>
       </div>
     </div>
  </div>
</template>
  
  <script>
  export default {
    data() {
      return {};
    },
  };
  </script>
  
  <style scoped>
  .customer{
    width: 100%;
    position: relative;
    /* height: 480px; */
    background-image: url(../assets//images/bj.jpg);
    background-repeat: no-repeat;
    background-position: top center;
    background-size: cover;
    padding: 150px 0;
  }
  .customer .title{
    text-align: center;
    color: #fff;
  }
  .customer .title h1{
    font-size: 36px;
    margin-bottom: 20px;
  }
  .customer .title p{
    font-size: 18px;
  }

 
  </style>
  